import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDocument = () => {
  return (
    <g>
      <path d="m5.94 0 8.012.012C14.53.013 15 .483 15 1.062v13.883c0 .58-.47 1.05-1.05 1.05H2.05c-.58 0-1.05-.47-1.05-1.05V4.935L5.94 0zM7 1.5v3.445c0 .541-.41.987-.936 1.044l-.114.006H2.5v8.5h11V1.51L7 1.5zM5.5 2.558 3.561 4.495H5.5V2.557z" />
    </g>
  );
};

export default withIcon(IconDocument);
